module.exports = __webpack_public_path__ + "img/meituan.017fc009.png";